import type { ReactElement, ReactNode } from 'react';
import React, { Children } from 'react';

import { useTabs } from '../Tabs';

type TabListProps = {
  children?: ReactNode;
};
function TabList({ children }: TabListProps) {
  const { activeIndex, id, onSelectTab, onChange } = useTabs();
  return (
    <div className="TabList" role="tablist">
      {Children.map(children, (child, index) =>
        React.cloneElement(child as ReactElement, {
          id: `${id}-tab-${index}`,
          'aria-controls': `${id}-panel-${index}`,
          isActive: index === activeIndex,
          onSelect: (event: React.MouseEvent | React.KeyboardEvent) => {
            event.preventDefault();
            if (React.isValidElement(child) && child.props?.isDisabled) {
              return;
            }
            onSelectTab(index);
            onChange({ index });
          },
        }),
      )}
    </div>
  );
}

TabList.displayName = 'TabList';

export { TabList };
